import React from 'react';
import {config} from "../../../../config";
import Icon from "../../../components/Icon";
import {SelectField} from "../../../components/FormField";

const MeetInformationsSettings = ({
                                      information = [], informationsLength = 0, handleProfileInformations = () => {
    }
                                  }) => {
    return (
        <div className={`column flex-table-column`}>
            {informationsLength === 2 && (
                <div className="flex-table-content">
                    <div
                        className={`flex-table-head-title ${information.sex === 0 ? 'him' : information.sex === 1 ? 'her' : ''}`}>
                        <Icon type={config.genderClass[information.sex]}/>
                        {information.sex === 0 ? (
                            "Lui"
                        ) : information.sex === 1 && (
                            "Elle"
                        )}
                    </div>
                </div>
            )}
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Une position sexuelle</div>
                <SelectField value={information.sexualPosition}
                             onChange={(event) => handleProfileInformations(information._id, "sexualPosition", event.target.value)}>
                    {config.sexualPosition.map((name, sexualPositionIndex) => <option value={sexualPositionIndex}
                                                                                      key={sexualPositionIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Un objet fétichiste</div>
                <SelectField value={information.fetishObject}
                             onChange={(event) => handleProfileInformations(information._id, "fetishObject", event.target.value)}>
                    {config.fetishObject.map((name, fetishObjectIndex) => <option value={fetishObjectIndex}
                                                                                  key={fetishObjectIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Une partie de son corps</div>
                <SelectField value={information.partnerBodyPart}
                             onChange={(event) => handleProfileInformations(information._id, "partnerBodyPart", event.target.value)}>
                    {config.partnerBodyPart.map((name, partnerBodyPartIndex) => <option value={partnerBodyPartIndex}
                                                                                        key={partnerBodyPartIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Une partie de votre corps</div>
                <SelectField value={information.bodyPart}
                             onChange={(event) => handleProfileInformations(information._id, "bodyPart", event.target.value)}>
                    {config.bodyPart.map((name, bodyPartIndex) => <option value={bodyPartIndex}
                                                                          key={bodyPartIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Un lieu où faire l'amour</div>
                <SelectField value={information.placeToHaveFetishSex}
                             onChange={(event) => handleProfileInformations(information._id, "placeToHaveFetishSex", event.target.value)}>
                    {config.placeToHaveFetishSex.map((name, placeToHaveFetishSexIndex) => <option
                        value={placeToHaveFetishSexIndex} key={placeToHaveFetishSexIndex}>{name}</option>)}
                </SelectField>
            </div>

            <div className="flex-table-content">
                <div className={"flex-table-label"}>Taille</div>
                <SelectField value={information.size}
                             onChange={(event) => handleProfileInformations(information._id, "size", event.target.value)}>
                    {config.size.map((name, sizeIndex) => <option value={sizeIndex} key={sizeIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Poids</div>
                <SelectField value={information.weight}
                             onChange={(event) => handleProfileInformations(information._id, "weight", event.target.value)}>
                    {config.weight.map((name, weightIndex) => <option value={weightIndex}
                                                                      key={weightIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Yeux</div>
                <SelectField value={information.eyesColor}
                             onChange={(event) => handleProfileInformations(information._id, "eyesColor", event.target.value)}>
                    {config.eyesColor.map((name, eyesColorIndex) => <option value={eyesColorIndex}
                                                                            key={eyesColorIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Cheveux</div>
                <SelectField value={information.hairColor}
                             onChange={(event) => handleProfileInformations(information._id, "hairColor", event.target.value)}>
                    {config.hairColor.map((name, hairColorIndex) => <option value={hairColorIndex}
                                                                            key={hairColorIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Look</div>
                <SelectField value={information.lookStyle}
                             onChange={(event) => handleProfileInformations(information._id, "lookStyle", event.target.value)}>
                    {config.lookStyle.map((name, lookStyleIndex) => <option value={lookStyleIndex}
                                                                            key={lookStyleIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Pilosité</div>
                <SelectField value={information.hairiness}
                             onChange={(event) => handleProfileInformations(information._id, "hairiness", event.target.value)}>
                    {config.hairiness.map((name, hairinessIndex) => <option value={hairinessIndex}
                                                                            key={hairinessIndex}>{name}</option>)}
                </SelectField>
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Personnalité</div>
                <SelectField
                    onChange={(event) => handleProfileInformations(information._id, "personality", event.target.value)}>
                    {config.personality.map((name, personalityIndex) => <option value={personalityIndex}
                                                                                key={personalityIndex}>{name}</option>)}
                </SelectField>
                {information.personality && information.personality.length > 0 && (
                    <div className={"row wrap tag-list"}>
                        {information.personality.map((item, index) => (
                            <span className={"tag selected-personality"} key={index}>{config.personality[item]} <span
                                onClick={() => handleProfileInformations(information._id, "personality", item)}><Icon
                                type={"close"}/></span></span>
                        ))}
                    </div>
                )}
            </div>
            <div className="flex-table-content">
                <div className={"flex-table-label"}>Fumeur</div>
                <SelectField value={information.smoker}
                             onChange={(event) => handleProfileInformations(information._id, "smoker", event.target.value)}>
                    {config.smoker.map((name, smokerIndex) => <option value={smokerIndex}
                                                                      key={smokerIndex}>{name}</option>)}
                </SelectField>
            </div>
        </div>
    )
};

export default MeetInformationsSettings;